import { render } from "./WirepasAssetDetailView.vue?vue&type=template&id=66c47486&scoped=true&ts=true"
import script from "./WirepasAssetDetailView.vue?vue&type=script&lang=ts"
export * from "./WirepasAssetDetailView.vue?vue&type=script&lang=ts"

import "./WirepasAssetDetailView.vue?vue&type=style&index=0&id=66c47486&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66c47486"]])

export default __exports__